import { apiFetch } from "@/lib/api-client";
import { colorFromIndex } from "@/lib/patient-tags/colors";
export function mapApiPatientTag(tag) {
    var _a;
    return {
        id: tag.id,
        key: tag.key,
        name: tag.name,
        colorIndex: tag.color_index,
        color: colorFromIndex(tag.color_index),
        usageCount: (_a = tag.usage_count) !== null && _a !== void 0 ? _a : 0,
    };
}
export async function fetchDoctorPatientTags(doctorId, token) {
    const res = await apiFetch(`/api/doctors/${doctorId}/patient_tags`, {
        token,
    });
    if (!res.ok) {
        throw new Error(`fetch doctor tags failed: ${res.status}`);
    }
    const data = (await res.json());
    return data.tags.map(mapApiPatientTag);
}
export async function createDoctorPatientTag(doctorId, token, body) {
    const res = await apiFetch(`/api/doctors/${doctorId}/patient_tags`, {
        method: "POST",
        token,
        body: JSON.stringify(body),
    });
    if (!res.ok) {
        throw new Error(`create tag failed: ${res.status}`);
    }
    const data = (await res.json());
    return mapApiPatientTag(data.tag);
}
export async function updateDoctorPatientTag(doctorId, tagId, token, body) {
    const res = await apiFetch(`/api/doctors/${doctorId}/patient_tags/${tagId}`, {
        method: "PATCH",
        token,
        body: JSON.stringify(body),
    });
    if (!res.ok) {
        throw new Error(`update tag failed: ${res.status}`);
    }
    const data = (await res.json());
    return mapApiPatientTag(data);
}
export async function deleteDoctorPatientTag(doctorId, tagId, token) {
    const res = await apiFetch(`/api/doctors/${doctorId}/patient_tags/${tagId}`, {
        method: "DELETE",
        token,
    });
    if (!res.ok && res.status !== 204) {
        throw new Error(`delete tag failed: ${res.status}`);
    }
}
export async function fetchPatientTags(patientId, token) {
    const res = await apiFetch(`/api/patients/${patientId}/patient_tags`, {
        token,
    });
    if (!res.ok) {
        throw new Error(`fetch patient tags failed: ${res.status}`);
    }
    const data = (await res.json());
    return data.tags.map(mapApiPatientTag);
}
export async function assignPatientTag(patientId, tagId, token) {
    const res = await apiFetch(`/api/patients/${patientId}/patient_tags/${tagId}`, { method: "POST", token });
    if (!res.ok) {
        throw new Error(`assign tag failed: ${res.status}`);
    }
    const data = (await res.json());
    return data.tags.map(mapApiPatientTag);
}
export async function unassignPatientTag(patientId, tagId, token) {
    const res = await apiFetch(`/api/patients/${patientId}/patient_tags/${tagId}`, { method: "DELETE", token });
    if (!res.ok) {
        throw new Error(`unassign tag failed: ${res.status}`);
    }
    const data = (await res.json());
    return data.tags.map(mapApiPatientTag);
}
export async function replacePatientTags(patientId, token, body) {
    const res = await apiFetch(`/api/patients/${patientId}/patient_tags`, {
        method: "PUT",
        token,
        body: JSON.stringify(body),
    });
    if (!res.ok) {
        throw new Error(`replace patient tags failed: ${res.status}`);
    }
    const data = (await res.json());
    return data.tags.map(mapApiPatientTag);
}
